<template>
  <div>
    <div>
      <div class="col">
        <div class="CadastrarServentia--header row align-items-center justify-content-between text-center">
          <div class="col-2" />
          <div class="col">
            Ctrl. frente e verso
          </div>
          <div class="col">
            Pág. Inicial
          </div>
          <div class="col">
            Lado inicial
          </div>
          <div class="col">
            Pág. Final
          </div>
          <div class="col">
            Lado Final
          </div>
          <div class="col">
            Qtd. termo/página
          </div>
          <div class="col">
            Qtd. páginas por Registro
          </div>
          <div class="col">
            Qtd. páginas
          </div>
        </div>
        <div v-for="(item, index) in listaConfig"
             :key="`config_livro_${ _uid }_${ index }`"
             class="CadastrarServentia--item row align-items-center justify-content-between text-center">
          <div class="col-2 text-bold text-left">
            <div class="pl-2">
              {{ item.titulo }}
            </div>
          </div>
          <div class="col">
            <b-form-checkbox
              v-model="item.frente_verso"
              switch
              :value="1" />
          </div>
          <div class="col text-bold">
            <input v-model="item.pag_inicial"
                   v-validate="'max_value:1998'"
                   type="number"
                   class="form-control form-control-sm"
                   max="1998"
                   min="1"
                   :name="`pag_inicial_${ index }`"
                   :class="{ 'is-invalid': errors.has(`pag_inicial_${ index }`) }">
          </div>
          <div class="col text-bold">
            <select v-model="item.lado_inicial"
                    v-validate="{ required: !!item.frente_verso }"
                    class="form-control form-control-sm"
                    :name="`lado_inicial_${ index }`"
                    :class="{ 'is-invalid': errors.has(`lado_inicial_${ index }`) }"
                    :disabled="!item.frente_verso">
              <option :value="null">
                Lado:
              </option>
              <option value="FRENTE">
                FRENTE
              </option>
              <option value="VERSO">
                VERSO
              </option>
            </select>
          </div>
          <div class="col text-bold">
            <input v-model="item.pag_final"
                   v-validate="'max_value:1998'"
                   type="number"
                   class="form-control form-control-sm"
                   max="1998"
                   min="1"
                   :name="`pag_final_${ index }`"
                   :class="{ 'is-invalid': errors.has(`pag_final_${ index }`) }">
          </div>
          <div class="col text-bold">
            <select v-model="item.lado_final"
                    v-validate="{ required: !!item.frente_verso }"
                    class="form-control form-control-sm"
                    :name="`lado_final_${ index }`"
                    :class="{ 'is-invalid': errors.has(`lado_final_${ index }`) }"
                    :disabled="!item.frente_verso">
              <option :value="null">
                Lado:
              </option>
              <option value="FRENTE">
                FRENTE
              </option>
              <option value="VERSO">
                VERSO
              </option>
            </select>
          </div>
          <div class="col text-bold">
            <input v-model="item.qtd_termo"
                   type="number"
                   class="form-control form-control-sm"
                   min="1">
          </div>
          <div class="col text-bold">
            <input v-model="item.qtd_pag_por_registro"
                   type="number"
                   class="form-control form-control-sm"
                   min="1">
          </div>
          <div class="col text-bold">
            {{ calcQtdPage(item) }}
          </div>
        </div>
      </div>
    </div>

    <div v-if="!propWizard"
         class="d-flex justify-content-end mt-2">
      <div class="d-inline-block">
        <button class="btn btn-sm btn-primary"
                type="submit"
                @click="sendSequence()">
          Salvar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { listaConfig } from '@/utils/serventiaLists'
  import Swal from 'sweetalert2'
  import { mapGetters } from 'vuex'

  /* constants */
  import objSwal from '@/constants/swalValues'

  /* services */
  import LivroService from '@/services/LivroService'

  export default {
    name: 'FormConfigLivros',
    props: {
      propWizard: {type: Boolean, default: false}
    },
    data () {
      return { listaConfig }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId',
      }),
    },
    watch: {
      listaConfig () {
        if (this.propWizard) this.$emit('changed', this.listaConfig)
      }
    },
    mounted () {
      this.getData()
    },
    methods: {
      calcQtdPage (item) {
        // método que retorna o calculo de qtd de paginas
        let qtd
        if (!item.frente_verso) {
          // Controle frente/verso" = NÃO
          // Página final - página inicial + 1
          qtd = (item.pag_final - item.pag_inicial) + 1
        } else {
          // Controle frente/verso" = Sim
          // Página final - página inicial + 1;
          qtd = ((item.pag_final - item.pag_inicial) + 1) * 2

          // (Se a página inicial = Verso: subtrair 1 do resultado.
          // Se a página final = Frente: subtrair 1 do resultado
          item.lado_inicial == 'VERSO' && qtd--
          item.lado_final == 'FRENTE' && qtd--
        }

        item.qtd_paginas = qtd
        return qtd
      },
      async sendSequence () {
        this.$validator.validate().then(async res => {
          if (res) {
            try  {
              loader({ text: 'Atualizando dados', active: true })
              let listaEnviados = []
              objSwal.success.title = 'Dados Atualizados!'
              objSwal.success.text = ''


              for (let val of this.listaConfig) {
                let objEnvio = { ...val, cartorio_id: this.$store.state.auth.cartorio_id }
                delete objEnvio.titulo

                await LivroService.sendConfigLivro(objEnvio).then(res => {
                  listaEnviados.push({ ...res.data, livroEnviado: val })
                }).finally(loader({ text: '', active: false }))
              }

              this.getData()

              return Swal.fire(objSwal.success)
            } catch (e) {
              const message = getErrors(e)

              displayMessage('error', 'Erro ao salvar configuração do livro!', message.message)
            } finally {
              loader({ text: '', active: false })
            }
          } else {
            displayMessage('error', 'Preencha os campos corretamente!')
          }
        })
      },
      async getData () {
        loader({ text: 'Buscando dados...', active: true })

        const params = {
          cartorio_id: this.$store.state.auth.cartorio_id
        }

        await LivroService.getConfigLivro(params).then((res) => {
          return this.listaConfig = this.listaConfig.map(val => {
            let check = res.data.filter(item => (item.livro === val.livro))
            return check.length ? { ...val, ...check[0] } : val
          })
        }).finally(loader({ text: '', active: false }))
      }
    }
  }
</script>
<style lang="scss">
  .CadastrarServentia {
    &--header {
      background-color: #01bfa5;
      border-radius: 5px 5px 0 0;
      font-size: 15px;
      font-weight: bold;
      height: 50px;
    }

    &--item {
      border-bottom: 1px solid black;
      border-left: 1px solid black;
      border-right: 1px solid black;
      padding: 8px 0;
    }

    &--item input {
      text-align: center;
      max-width: 90px;
    }
  }
</style>
